// Ver varias temporadas a la vez en Pedidos.
//
// Por que: un club puede tener FLAG y TACKLE corriendo al mismo tiempo, y un pedido
// va a UN proveedor -- puede llevar jerseys de los dos en la misma orden, como se
// haria por WhatsApp. El dueno: "si hay mas de una temporada corriendo, esta bien.
// Por eso me interesa que moverme entre temporadas sea mas suave".
//
// El modelo ya lo permitia y nadie lo habia usado: en `pedidos_uniforme`,
// `temporada_id` y `deporte` son nullable y no gobiernan ninguna logica. La regla
// "un pedido es de un solo deporte" era una decision de pantalla, no de datos.

const unirPorId = (listas) => {
  const porId = new Map()
  listas.forEach((lista) => (lista || []).forEach((x) => {
    if (x && !porId.has(x.id)) porId.set(x.id, x)
  }))
  return [...porId.values()]
}

// Junta las matrices de varias temporadas en una sola.
//
// Cada entrega se queda con su `temporada_id`: sin eso, guardar una talla la
// guardaria en la temporada equivocada. Y el `id` se desambigua, porque el id
// sintetico de una celda sin registro ("plan-<jugador>-<prenda>") es el MISMO en
// dos temporadas: marcar una marcaria las dos.
export const unirMatrices = (matrices = []) => {
  const entregas = []
  ;(matrices || []).forEach(({ temporadaId, data }) => {
    ;(data?.entregas || []).forEach((e) => {
      entregas.push({
        ...e,
        temporada_id: temporadaId,
        id: e.asignacionId || `${temporadaId}:${e.id}`,
      })
    })
  })

  return {
    entregas,
    prendas: unirPorId((matrices || []).map((m) => m.data?.prendas)),
    jugadores: unirPorId((matrices || []).map((m) => m.data?.jugadores)),
    temporadaPrendas: (matrices || []).flatMap((m) => m.data?.temporadaPrendas || []),
  }
}

// Que temporada se le pone al pedido. Si mezcla, ninguna: el campo es opcional y
// escribir una de las dos seria mentir sobre las otras piezas.
export const temporadaDelPedido = (piezas = []) => {
  const temporadas = [...new Set((piezas || []).map((p) => p.temporada_id).filter(Boolean))]
  return temporadas.length === 1 ? temporadas[0] : null
}

// Como se etiqueta una temporada en un chip.
//
// El deporte hay que verlo -- el selector viejo no lo mostraba y por eso los clubes
// acabaron escribiendolo en el NOMBRE ("FLAG - Julio - Diciembre 2026"). Pero
// anteponerlo siempre lo dice dos veces y en movil cada chip se come un renglon.
//
// Se usa solo la PRIMERA palabra del deporte: "Flag Football · Primavera 2026" es
// ruido; "Flag · Primavera 2026" se lee de un golpe.
export const etiquetaTemporada = (temporada = {}, deporteLabel = () => '') => {
  const nombre = (temporada.nombre || '').trim()
  if (!temporada.deporte_id) return nombre

  const corto = String(deporteLabel(temporada.deporte_id) || '').trim().split(/\s+/)[0]
  if (!corto) return nombre
  if (!nombre) return corto

  const yaLoDice = nombre.toLowerCase().includes(corto.toLowerCase())
    || nombre.toLowerCase().includes(String(temporada.deporte_id).toLowerCase())
  return yaLoDice ? nombre : `${corto} · ${nombre}`
}
